import PropTypes from 'prop-types';
import React, { Component } from "react";
import TypeSelect from "./TypeSelect"
import Badge from "./Badge"
import searchMessages from "../../messages/search"
import { injectIntl } from "react-intl"
import { getStyles } from '../../styles/dynamicStyles';

class FilterSuggest extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    searchValue: PropTypes.string,
    suggestions: PropTypes.array,
    activeOptions: PropTypes.array,
    onDeleteOption: PropTypes.func.isRequired,
    onSelectOption: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string
  }

  static defaultProps = {
    searchValue: ""
  }

  onChange = ({ target: { value } }) => {
    this.props.onChange(value)
  }

  render() {
    const {
      searchValue,
      activeOptions,
      onDeleteOption,
      onSelectOption,
      suggestions,
      intl
    } = this.props

    let { placeholder } = this.props

    if (!placeholder) {
      placeholder = intl.formatMessage(searchMessages.filterTextPlaceholder)
    }

    return (
      <ul className="c-results-filters__list menu vertical nested" 
          style={getStyles('c-results-filters__list')}>
        <li className="c-results-filters__single-block" 
            style={getStyles('c-results-filters__single-block')}>
          {activeOptions && (
            <div className="c-results-filters__active-tags">
              {activeOptions.map((option, i) => (
                <Badge
                  key={i}
                  isClosable
                  onClick={e => onDeleteOption(option)}
                  closeBtnTitle="Remove"
                >
                  {option}
                </Badge>
              ))}
            </div>
          )}
          <TypeSelect
            value={searchValue}
            options={suggestions}
            placeholder={placeholder}
            handleChange={this.onChange}
            handleSelected={onSelectOption}
          />
        </li>
      </ul>
    )
  }
}
export default injectIntl(FilterSuggest)



// WEBPACK FOOTER //
// ./webapp/components/elements/FilterSuggest.js